import React from 'react';
var typeComponentMap = {
    string: require('./StringCell').default,
    custom: require('./CustomCell').default,
    date: require('./DateCell').default,
    field: require('./FieldCell').default,
};
var ChangelogCell = function (props) {
    var field = props.field, _a = props.cellType, cellType = _a === void 0 ? 'string' : _a, data = props.data, metadata = props.metadata, timeZone = props.timeZone;
    var ComponentToRender = typeComponentMap[cellType];
    return (data[field] != undefined ?
        React.createElement(ComponentToRender, { value: data[field], data: data, metadata: metadata, field: field, timeZone: timeZone }) : null);
};
export default ChangelogCell;
//# sourceMappingURL=ChangelogCell.js.map